import { property } from "lit/decorators.js";
import "./utils.js";
const defaultReflectValue = false;
const prop = (options) => {
  const reflect = (options == null ? void 0 : options.reflect) !== void 0 ? options.reflect : defaultReflectValue;
  return property({ ...options, reflect });
};
export {
  prop
};
